import React from 'react';
import PropTypes from 'prop-types';

import {
  DATA_TABLE_SOURCE_RENTLINX_LEAD_NOTES,
  DATA_TABLE_VIEW_ID_PARTNER_NOTES_ALL,
} from 'common/dataTableConstants';

import SrCreateNoteForm from 'client/components/SrCreateNoteForm';
import SrDarkModal from 'client/components/SrDarkModal';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrNotesList, {
  SR_RENTLINX_LEAD_NOTES,
} from 'client/components/SrNotesList';

const SrRentlinxLeadNotesModal = ({
  rentlinxLeadId,
  dispatch,
  currentUser,
  onClose,
  onUpdate,
}) => {
  return (
    <SrDarkModal onClose={onClose}>
      <div className='adminModal'>
        <div
          className='householdNotes'
          onClick={(event) => event.stopPropagation()}
        >
          <SrText weight='bolder' size='larger'>
            NOTES
          </SrText>
          <SrBox marginTop='20px' />
          <SrDataTableConnected
            itemsPropName='notes'
            dataSource={DATA_TABLE_SOURCE_RENTLINX_LEAD_NOTES}
            rootViewId={DATA_TABLE_VIEW_ID_PARTNER_NOTES_ALL}
            initialViewSettings={{
              sort: {
                createdDate: 'desc',
              },
              filter: {
                rentlinxLeadId,
              },
            }}
          >
            {({ notes, reloadItems, onInfiniteScrollWrapperRef }) => (
              <>
                <div ref={onInfiniteScrollWrapperRef}>
                  <SrNotesList
                    type={SR_RENTLINX_LEAD_NOTES}
                    openedInModal
                    notes={notes}
                    dispatch={dispatch}
                    reloadDataTable={(noteId) => {
                      reloadItems({
                        count: 1,
                        filter: { 'rentlinxLeadNotes.id': noteId },
                      });

                      if (onUpdate) {
                        onUpdate();
                      }
                    }}
                    currentUser={currentUser}
                  />
                </div>
                <SrCreateNoteForm
                  rentlinxLeadId={rentlinxLeadId}
                  dispatch={dispatch}
                  reloadDataTable={(noteId) => {
                    reloadItems({
                      count: 1,
                      filter: { 'rentlinxLeadNotes.id': noteId },
                    });

                    if (onUpdate) {
                      onUpdate();
                    }
                  }}
                />
              </>
            )}
          </SrDataTableConnected>
        </div>
      </div>
    </SrDarkModal>
  );
};

SrRentlinxLeadNotesModal.propTypes = {
  rentlinxLeadId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func,
};

SrRentlinxLeadNotesModal.displayName = 'SrRentlinxLeadNotesModal';

export default SrRentlinxLeadNotesModal;
